export function jsonToFormData<T extends Record<string, any>>(
  data: T,
  filesKey: (keyof T)[] = []
) {
  const formData = new FormData()

  for (const key in data) {
    if (filesKey.includes(key) && data[key] && data[key].length > 0) {
      for (const file of data[key] as any) {
        formData.append(key, file)
      }
    } else if (data[key] !== null) {
      formData.append(key, data[key])
    }
  }

  return formData
}
